import React from 'react';
import {
  HomeOutlined,
  // SendOutlined,
  // IdcardOutlined,
  NotificationOutlined,
  LinkOutlined,
  LineChartOutlined,
  SketchOutlined,
  UserSwitchOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  StarOutlined,
  FacebookOutlined,
  SettingOutlined,
  // RocketOutlined,
} from '@ant-design/icons';
import URL from '../../configs/baseUrl';
import {
  isAccessGroupExist,
  isTeamAccessGroupExist,
} from '../../utils/accessGroup';
import {
  adminAccessGroupSlugs,
  teamAccessGroupsSlugs,
} from '../../configs/accessGroup';

const menuAvailable = JSON.parse(process.env.REACT_APP_AVAILABLE_MENU);

export const menuAdmin = [
  {
    to: URL.USERS,
    label: 'Users',
    role: 'admin',
    icon: <UserSwitchOutlined />,
    isAvailable: menuAvailable.USERS,
    isShow: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_USER,
    }),
  },
  {
    to: URL.TEAMS,
    label: 'Teams',
    role: 'admin',
    icon: <TeamOutlined />,
    isAvailable: menuAvailable.TEAMS,
    isShow: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_TEAM,
    }),
  },
  {
    to: URL.LICENSES,
    label: 'Licenses',
    role: 'admin',
    icon: <StarOutlined />,
    isAvailable: menuAvailable.LICENSES,
    isShow: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_LICENSE,
    }),
  },
  {
    to: URL.PAYMENTS,
    label: 'Payments',
    role: 'admin',
    icon: <UnorderedListOutlined />,
    isAvailable: menuAvailable.PAYMENTS,
    isShow: isAccessGroupExist({
      slug: adminAccessGroupSlugs.LIST_PAYMENT,
    }),
  },
];

export const menuTeam = [
  {
    to: URL.MEMBERS,
    label: 'Members',
    role: 'admin',
    icon: <TeamOutlined />,
    isAvailable: menuAvailable.MEMBERS,
    isShow: isTeamAccessGroupExist({
      slug: teamAccessGroupsSlugs.LIST_MEMBERS,
    }),
  },
  {
    to: URL.TEAM_SETTINGS,
    label: 'Settings',
    role: 'admin',
    icon: <SettingOutlined />,
    isAvailable: menuAvailable.TEAM_SETTINGS,
    isShow:
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.TEAM_SETTING,
      }) ||
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.TEAM_LICENSE,
      }) ||
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.PAYMENT_HISTORY,
      }) ||
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.CREATE_TEAM_PAYMENT,
      }),
  },
];

export const menuPersonal = [
  {
    to: URL.SETTING,
    label: 'Settings',
    role: 'admin',
    icon: <SettingOutlined />,
    isAvailable: menuAvailable.SETTING,
  },
];

export const mainMenu = [
  {
    to: URL.DASHBOARD,
    label: 'Dashboard',
    role: 'admin',
    icon: <HomeOutlined />,
    isAvailable: menuAvailable.DASHBOARD,
    isShow: isTeamAccessGroupExist({
      slug: teamAccessGroupsSlugs.DASHBOARD,
    }),
  },
  {
    to: URL.SOCIAL_ACCOUNTS,
    label: 'Social Accounts',
    role: 'admin',
    icon: <FacebookOutlined />,
    isAvailable: menuAvailable.SOCIAL_ACCOUNTS,
    isShow: isTeamAccessGroupExist({
      slug: teamAccessGroupsSlugs.LIST_SOCIAL_ACCOUNT,
    }),
  },
  // {
  //   to: URL.CONTACTS,
  //   label: 'Contacts',
  //   role: 'admin',
  //   icon: <IdcardOutlined />,
  //   isAvailable: menuAvailable.CONTACTS,
  //   isShow: isTeamAccessGroupExist({
  //     slug: teamAccessGroupsSlugs.LIST_CONTACTS,
  //   }),
  // },
  // {
  //   to: URL.SCRIBERS,
  //   label: 'Scriber',
  //   role: 'admin',
  //   icon: <SendOutlined />,
  //   isAvailable: menuAvailable.SCRIBERS,
  //   isShow: true,
  // },
  {
    to: URL.PROMOTER_CAMPAIGNS,
    label: 'Promoter',
    role: 'admin',
    icon: <NotificationOutlined />,
    isAvailable: menuAvailable.PROMOTER,
    isShow:
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.LIST_CAMPAIGN,
      }) ||
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.LIST_ADS_SET,
      }) ||
      isTeamAccessGroupExist({
        slug: teamAccessGroupsSlugs.LIST_ADS,
      }),
  },
  {
    to: URL.INTEGRATOR,
    label: 'Integrator',
    role: 'admin',
    icon: <LinkOutlined />,
    isAvailable: menuAvailable.INTEGRATOR,
    isShow: isTeamAccessGroupExist({
      slug: teamAccessGroupsSlugs.LIST_INTEGRATOR,
    }),
  },
  {
    to: URL.ANALYZER,
    label: 'Analyzer',
    role: 'admin',
    icon: <LineChartOutlined />,
    isAvailable: menuAvailable.ANALYZER,
    isShow: isTeamAccessGroupExist({
      slug: teamAccessGroupsSlugs.LIST_ANALYZER,
    }),
  },
  {
    to: URL.REFINER,
    label: 'Refiner',
    role: 'admin',
    icon: <SketchOutlined />,
    isAvailable: menuAvailable.REFINER,
    isShow: isTeamAccessGroupExist({
      slug: teamAccessGroupsSlugs.LIST_REFINER,
    }),
  },
  // {
  //   to: URL.COMING,
  //   label: 'Upgrade Account',
  //   role: 'team',
  //   icon: <RocketOutlined />,
  //   className: 'component_upgrade_account',
  // },
];

export const filteredMainMenu = mainMenu.filter((item) => {
  return item.isShow;
});
export const filteredTeamMenu = menuTeam.filter((item) => {
  return item.isShow;
});

export const upgradeAccountData = {};
